module.exports = __webpack_public_path__ + "static/media/newblue.6963aa98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newblue.png
// module id = 387
// module chunks = 0